module.exports = __webpack_public_path__ + "img/alarm.c1ae6f75.png";